<template>
  <el-form class="collaborator-table">
    <!-- TODO: May need to rewrite this component, to support table + form validation -->
    <el-table
      :data="humans"
      style="width: 100%"
      :show-header="showHeader"
    >

      <el-table-column
        v-if="!defaultRole"
        prop="role"
        label="Role"
        min-width="150"
      >
        <template slot-scope="scope">
          <EditView
            style="text-transform: capitalize;"
            v-model="scope.row.role"
            @input="updateUnsavedStatus"
            :editable="scope.row.editable"
          >
            <el-select
              v-model="scope.row.role"
              placeholder="Pick a role"
              :filterable="enableTyping"
              :allow-create="enableTyping"
              width="100">
              <el-option
                v-for="item in roles"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </EditView>
        </template>
      </el-table-column>

      <el-table-column
        label="First name"
        min-width="150"
      >
        <template slot-scope="scope">
          <EditView
            v-model="scope.row.first_name"
            @input="updateUnsavedStatus"
            :editable="scope.row.editable"
            :placeholder="showHeader ? undefined : 'First name'"
          />
        </template>
      </el-table-column>

      <el-table-column
        label="Last name"
        min-width="150"
      >
        <template slot-scope="scope">
          <EditView
            v-model="scope.row.last_name"
            @input="updateUnsavedStatus"
            :editable="scope.row.editable"
            :placeholder="showHeader ? undefined : 'Last name'"
          />
        </template>
      </el-table-column>

      <el-table-column
        label="Email"
        min-width="250"
      >
        <template slot-scope="scope">
          <EditView
            v-model="scope.row.email"
            @input="updateUnsavedStatus"
            :editable="scope.row.editable"
            :placeholder="showHeader ? undefined : 'Email'"
          />
        </template>
      </el-table-column>

      <el-table-column
        fixed="right"
        label="Action"
        v-if="showAction && !disabled"
        :width="isTemporary ? 40 : 80">
        <template slot-scope="scope">
          <template v-if="isTemporary">
            <el-button
              type="text" size="small"
              icon="el-icon-delete"
              @click="removeCollaborator(scope.$index)"
            ></el-button>
          </template>

          <!-- Provides options for saving and editing -->
          <template v-else>
            <span v-if="scope.row.editable">
              <el-button
                type="text" size="small"
                @click="saveCollaborator(scope.$index)"
              >Save</el-button>
              <el-button
                type="text" size="small"
                icon="el-icon-close"
                @click="cancelEdit(scope.$index)"
              ></el-button>
            </span>
            <span v-else>
              <el-button
                type="text" size="small"
                @click="editCollaborator(scope.$index)"
              >Edit</el-button>

              <el-button
                v-if="scope.row.id != null"
                type="text" size="small"
                icon="el-icon-delete"
                @click="removeCollaborator(scope.$index)"
              ></el-button>
              <el-button
                v-else
                type="text" size="small"
                icon="el-icon-loading"
              ></el-button>
            </span>
          </template>



        </template>
      </el-table-column>
      <template slot="empty"></template>
    </el-table>
  </el-form>
</template>

<script>
/**
  * Current modification to the cell of this component will directly modify the
  * parent value. Because of this, Create, Update and Delete method is by
  * default not required.
  *
  * If this is not desirable, we may need to relook into the data flow
  * of this module.
 */

import Vue from 'vue';
import Table from 'element-ui/lib/table';
import TableColumn from 'element-ui/lib/table-column';
import NOTIFY_CONSTANTS from '@/config/notify-constants';
import { COLLABORATOR_ROLES } from '@/assets/data/viddsee/collaboratorRoles';
import EditView from './EditView';

Vue.use(Table);
Vue.use(TableColumn);

const roles = COLLABORATOR_ROLES
  .filter(role => role !== 'Director')
  .map(role => ({
    label: role,
    value: role.toLowerCase(),
  }))
;

export default {
  components: {
    EditView,
  },
  props: {
    // Values
    value: {
      type: Array,
      required: true,
    },
    defaultRole: {},

    // UI State
    disabled: {
      type: Boolean,
      default: false,
    },
    showAction: {
      type: Boolean,
      default: true,
    },
    isTemporary: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      type: Boolean,
      default: true,
    },

    // Methods
    updateFn: {
      type: Function,
      default: (humanId, human) => Promise.resolve({ data: human }),
    },
    createFn: {
      type: Function,
      default: human => Promise.resolve({ data: human }),
    },
    removeFn: {
      type: Function,
      default: () => Promise.resolve(),
    },
    enableTyping: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      roles,
      buffer: [],
      hasUnsaved: false,
    };
  },
  computed: {
    humans() {
      return this.value;
    },
  },
  watch: {
    humans() {
      this.updateUnsavedStatus();
    },
  },
  methods: {
    cancelEdit(index) {
      Vue.set(this.humans[index], 'editable', false);

      if (this.buffer[index]) {
        Vue.set(this.humans, index, {
          ...this.buffer[index],
        });
      } else {
        Vue.delete(this.humans, index);
      }
    },
    editCollaborator(index) {
      // TODO: Ideally speaking, this component should keep a local copy of the array,
      //       so that the original data is not modified.
      //       For now, the collaborator component will always grab the network copy on mounted.
      //       Do a shallow copy first.
      this.buffer[index] = {
        ...this.humans[index],
      };
      Vue.set(this.humans[index], 'editable', true);
    },
    verifyCollaborator(index) {
      const human = this.humans[index];
      const notDirectorOtherwiseNeedEmail = human.role !== 'director' || human.email;

      const rules = [{
        prop: human.first_name,
        message: 'First name is required',
      }, {
        prop: human.last_name,
        message: 'Last name is required',
      }, {
        prop: human.role,
        message: 'Role is required',
      }, {
        prop: notDirectorOtherwiseNeedEmail,
        message: 'Email is required for director',
      }];

      const hasError = rules.find(rule => !rule.prop);

      return hasError;
    },
    saveCollaborator(index) {
      const collaboratorError = this.verifyCollaborator(index);
      if (collaboratorError) {
        this.$notify.error({
          title: 'Error',
          message: collaboratorError.message,
          duration: NOTIFY_CONSTANTS.DURATION.MEDIUM,
        });
        return;
      }

      const human = this.humans[index];
      const promise = (human.id == null)
        ? this.createFn(human, this.humans)
        : this.updateFn(human.id, human, this.humans);
      Vue.set(this.humans[index], 'editable', false);

      promise
        .then(({ data }) => {
          Vue.set(this.humans, index, data);
        })
      // TODO: Handle network errro
        .catch((error) => {
          Vue.set(this.humans[index], 'editable', false);
          throw error;
        })
        .then(() => {
          this.$emit('change', this.humans);
        });
    },
    removeCollaborator(index) {
      const human = this.humans[index];
      this.removeFn(human.id, this.humans)
        .then(() => {
          Vue.delete(this.humans, index);
        })
        // TODO: Handle network error
        .catch((error) => {
          throw error;
        })
        .then(() => {
          this.$emit('change', this.humans);
        });
    },
    updateUnsavedStatus() {
      const hasUnsaved = this.humans.some((humanObj) => {
        if (humanObj.editable) {
          if (this.buffer.length === 0) {
            return (humanObj.first_name || '').trim() ||
                   (humanObj.last_name || '').trim() ||
                   (humanObj.email || '').trim();
          }
          return true;
        } else {
          return false;
        }
      });
      if (hasUnsaved !== this.hasUnsaved) {
        this.hasUnsaved = hasUnsaved;
        this.$emit('editing', hasUnsaved);
      }
    },
  },
};
</script>

<style>
.collaborator-table {
  box-shadow: 0px 0px 16px 0px rgba(0,0,0,0.05);
}
</style>



// WEBPACK FOOTER //
// src/components/Submission/steps/CollaboratorDetails/CollaboratorItem/CollaboratorTable.vue